module.exports = __webpack_public_path__ + "img/Internet (1).c27cdd61.png";